var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 843,
    height: 766,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M843 0H0v765C890.5 786.497 525.5 235.465 843 0z",
    fill: "#078DBE",
    fillOpacity: 0.8
  })));
}

export default __webpack_public_path__ + "66b6f4628a8d65c778adc7fd22217a1a.svg";
export { SvgInscription as ReactComponent };